<div class="review-improvement-container">
  <ngx-loading [show]="loading"></ngx-loading>

  <div class="review-improvement-card-sec">
    <div class="business-info">
      <div class="row">
        <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12">
          <div
            class="business-detail d-flex justify-content-center align-items-center flex-column"
          >
            <img [src]="logoUrl" *ngIf="logoUrl" class="img-responsive" />
            <p class="business-name">{{ businessName | titlecase }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="review-improvement-section">
      <div class="feedback-section">
        <img
          src="assets/images/review-feedback.svg"
          class="review-feedback-img img-responsive"
        />
        <div class="feedback-detail">
          <p class="user-name">Hello {{ customerName }}!</p>
          <p class="welcome-message">
            <span *ngIf="isShowThankYouScreen">
              {{ feedbackAlreadyGiven }}
            </span>
            <span *ngIf="!isShowThankYouScreen">
              {{ welcomeMessage }}
            </span>
          </p>
        </div>
        <ng-container *ngIf="!isShowThankYouScreen">
          <div class="feedback-slug-section">
            <div class="feedback-slug-area">
              <!-- 2 point scale -->
              <ng-container *ngIf="feedbackScale == '2'">
                <!-- 2 point scale - formal -->
                <ng-container *ngIf="consumerChoice == 'Formal'">
                  <div class="two-point-formal">
                    <ng-container *ngFor="let slug of twoPointFormal">
                      <div class="two-point-formal-each-icon">
                        <div
                          [ngClass]="{
                            'two-point-positive':
                              slug.rating_type == 'POSITIVE',
                            'two-point-negative': slug.rating_type == 'NEGATIVE'
                          }"
                          (click)="onSlugSelect(slug)"
                          [class.set-greyscale]="
                            selectedSlugRating &&
                            selectedSlugRating !== slug.rating
                          "
                          class="cursor-pointer"
                        >
                          <img
                            [src]="slug.icon"
                            class="img-responsive two-point-formal-icon"
                          />
                        </div>
                        <p class="icon-label">
                          {{
                            slug.rating_type == "POSITIVE"
                              ? "Good"
                              : "Could be better"
                          }}
                        </p>
                      </div>
                    </ng-container>
                    <!-- hide for testing -->
                    <!-- <div class="two-point-positive set-greyscale">
                  <img
                    src="assets/images/thumbs-up.svg"
                    class="img-responsive two-point-formal-icon"
                  />
                </div>
                <div class="two-point-negative">
                  <img
                    src="assets/images/thumbs-down.svg"
                    class="img-responsive two-point-formal-icon"
                  />
                </div> -->
                  </div>
                </ng-container>

                <!-- 2 point scale - friendly -->
                <ng-container *ngIf="consumerChoice == 'Friendly'">
                  <div class="two-point-friendly">
                    <div
                      *ngFor="let slug of twoPointFriendly"
                      class="two-point-friendly-div cursor-pointer"
                      [class.set-greyscale]="
                        selectedSlugRating && selectedSlugRating !== slug.rating
                      "
                      (click)="onSlugSelect(slug)"
                    >
                      <img
                        [src]="slug.icon"
                        class="img-responsive two-point-friendly-icon"
                      />
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- 5 point scale -->
              <ng-container *ngIf="feedbackScale == '5'">
                <!-- 5 point scale - Formal -->
                <ng-container *ngIf="consumerChoice == 'Formal'">
                  <ol class="five-point-formal smileylist">
                    <li
                      *ngFor="let slug of fivePointFormal"
                      [class.set-greyscale]="
                        selectedSlugRating && selectedSlugRating !== slug.rating
                      "
                      (click)="onSlugSelect(slug)"
                      class="cursor-pointer"
                    ></li>
                  </ol>
                </ng-container>

                <!-- 5 point scale - Friendly -->
                <ng-container *ngIf="consumerChoice == 'Friendly'">
                  <div class="five-point-friendly">
                    <div
                      *ngFor="let slug of fivePointFriendly"
                      [class.set-greyscale]="
                        selectedSlugRating && selectedSlugRating !== slug.rating
                      "
                      class="five-point-friendly-div cursor-pointer"
                      (click)="onSlugSelect(slug)"
                    >
                      <img
                        [src]="slug.icon"
                        class="img-responsive five-point-friendly-icon"
                      />
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- 10 point scale -->
              <ng-container *ngIf="feedbackScale == '10'">
                <!-- 10 point scale - Formal -->
                <ng-container *ngIf="consumerChoice == 'Formal'">
                  <div class="ten-point-formal">
                    <ng-container>
                      <div class="custom-slider mx-1">
                        <ngx-slider
                          [(value)]="tenPointValue"
                          [options]="options"
                          (valueChange)="
                            onSlugSelect({
                              scale_type:
                                this.DEFAULT_FEEDBACK_SCALE.TEN_POINT_SCALE,
                              ten_point_scale_on_load: true
                            })
                          "
                        ></ngx-slider>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div *ngIf="showFeedbackOption" class="feedback-text-section">
            <p class="feedback-text-heading">
              Please share your feedback below.{{
                (!this.isNegativeRating && !this.feedbackOnlyFlow) ? "(optional)" : ""
              }}
            </p>
            <div class="feedback-textarea-section">
              <textarea
                name="notes"
                rows="3"
                class="form-control feedback-textarea"
                [ngClass]="{
                  'red-error-class':
                    isInvalidFeedback && !feedbackText && (this.isNegativeRating || this.feedbackOnlyFlow)
                }"
                [(ngModel)]="feedbackText"
              ></textarea>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="showFeedbackOption && !isShowThankYouScreen">
        <div class="action-area">
          <button
            class="btn btn-submit"
            [disabled]="submitFeedbackClicked"
            (click)="onSubmitFeedBack()"
          >
            Submit Feedback
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <app-footer-powered-by-image *ngIf="showPoweredBy"></app-footer-powered-by-image>
</div>

<ng-template #thankyoumodal let-modal>
  <button
    style="z-index: 99999"
    type="button"
    class="close close-icon-modal"
    aria-label="Close"
    (click)="modal.close();showThankYouScreen(true);"
  >
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="col-lg-12 col-md-12 col-sm-12 thank-you-sec" style="width: auto">
    <div class="thank-you-icon-sec">
      <img src="assets/images/thank-you-icon.svg" class="img-responsive" />
    </div>
    <p class="thank-you-heading">Thank you for your feedback</p>
    <div class="thank-you-message-section">
      <p class="thank-you-message">
        {{ thankYouMessage }}
      </p>
      <p *ngIf="!feedbackOnlyFlow" class="thank-you-message-redirect">
        Please
        <a *ngIf="redirectLink" [href]="redirectLink" (click)="modal.close();" class="hyper-link-text">click here</a>
        <a *ngIf="!redirectLink" (click)="externalPlatformPage();modal.close();" class="hyper-link-text">click here</a>

        to review us.
      </p>
    </div>

    <div class="col-md-12 col-sm-12 text-center">
      <button class="btn btn-submit" (click)="modal.close();showThankYouScreen(true);">GOT IT</button>
    </div>
  </div>
</ng-template>
